/* hanf&natur Großhandel – Theme-JavaScript (ohne Abhängigkeiten) */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const S = (window.theme && window.theme.strings) || {};
  const LANG = document.documentElement.lang || 'de';

  /* ---------- MwSt-Schalter (Standard: aus = Netto) ---------- */
  const VAT_KEY = 'hn-vat';
  const setVat = (on) => {
    document.documentElement.classList.toggle('vat-on', on);
    $$('[data-vat-toggle]').forEach((btn) => {
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? S.vatOn : S.vatOff);
    });
    try { localStorage.setItem(VAT_KEY, on ? 'on' : 'off'); } catch (e) { /* privater Modus */ }
  };
  let vatOn = false;
  try { vatOn = localStorage.getItem(VAT_KEY) === 'on'; } catch (e) { vatOn = false; }
  setVat(vatOn);
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-vat-toggle]');
    if (!btn) return;
    setVat(!document.documentElement.classList.contains('vat-on'));
  });

  /* ---------- Header: Schatten beim Scrollen + Höhe als CSS-Variable ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    const setH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    setH();
    window.addEventListener('resize', setH);
  }

  /* ---------- Drawer (mobiles Menü) ---------- */
  let lastFocus = null;
  const openDrawer = (drawer, trigger) => {
    lastFocus = trigger || document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    $$('[aria-controls="' + drawer.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('a, button, summary', $('.drawer__panel', drawer));
    if (focusable) focusable.focus();
  };
  const closeDrawer = (drawer) => {
    drawer.hidden = true;
    document.body.style.overflow = '';
    $$('[aria-controls="' + drawer.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.drawerOpen);
      if (d) openDrawer(d, opener);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-drawer]'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-drawer]').forEach((d) => { if (!d.hidden) closeDrawer(d); });
    $$('details.filter[open]').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------- Mengen-Stepper ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = $('input', btn.closest('.qty'));
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    const step = parseInt(input.step || '1', 10);
    const cur = parseInt(input.value || String(min), 10) || min;
    const next = btn.dataset.qty === 'plus' ? cur + step : Math.max(min, cur - step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Verpackungseinheit: sichtbares Feld zählt VE (data-ve-count), das versteckte Feld
     (data-ve-qty, data-ve = Stück je VE) trägt die Stückzahl für Shopify. Läuft vor allen anderen change-Handlern. ---------- */
  const syncVe = (count) => {
    const hidden = count && $('input[data-ve-qty]', count.closest('.qty'));
    if (!hidden) return;
    const n = Math.max(parseInt(count.min || '1', 10), parseInt(count.value, 10) || 0);
    count.value = n;
    hidden.value = n * (parseInt(hidden.dataset.ve, 10) || 1);
  };
  document.addEventListener('change', (e) => {
    const count = e.target.closest && e.target.closest('input[data-ve-count]');
    if (count) syncVe(count);
  }, true);

  /* ---------- Zurück-Knopf: kam der Besucher genau von der Zielseite, per history.back() (Scrollposition/Filter bleiben) ---------- */
  document.addEventListener('click', (e) => {
    const back = e.target.closest('[data-back-link]');
    if (!back || e.metaKey || e.ctrlKey || e.shiftKey) return;
    try {
      const ref = new URL(document.referrer);
      const ziel = new URL(back.href, window.location.origin);
      if (ref.origin === window.location.origin && ref.pathname === ziel.pathname && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    } catch (err) { /* kein Referrer: normaler Link */ }
  });

  /* ---------- Toast ---------- */
  const toast = $('[data-toast]');
  let toastTimer;
  const showToast = (text) => {
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  };

  /* ---------- Warenkorb-Zähler ---------- */
  const formatMoney = (cents) => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  const refreshCart = async () => {
    try {
      const res = await fetch(window.theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      $$('[data-cart-total]').forEach((el) => { el.textContent = formatMoney(cart.total_price); });
    } catch (e) { /* ignorieren */ }
  };

  /* ---------- Warenkorb-Schublade ----------
     Neu zeichnen per Section Rendering API, Mengen per Positions-Schlüssel (key) über /cart/change.js.
     Der Kassen-Knopf sitzt im festen Fuß der Schublade, nur die Artikelliste scrollt. */
  const cartDrawer = $('[data-cart-drawer]');
  let cartLastFocus = null;
  const cartError = (msg) => {
    const el = cartDrawer && $('[data-cart-error]', cartDrawer);
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  };
  const renderCartDrawer = async () => {
    if (!cartDrawer) return;
    try {
      const res = await fetch(window.theme.routes.root_url + '?sections=cart-drawer', { headers: { Accept: 'application/json' } });
      const json = await res.json();
      const doc = new DOMParser().parseFromString(json['cart-drawer'] || '', 'text/html');
      const fresh = $('[data-cart-drawer-inner]', doc);
      const current = $('[data-cart-drawer-inner]', cartDrawer);
      if (fresh && current) current.replaceWith(fresh);
    } catch (e) { /* alter Stand bleibt sichtbar */ }
  };
  const openCartDrawer = (trigger) => {
    if (!cartDrawer) return;
    cartLastFocus = trigger || document.activeElement;
    cartError('');
    cartDrawer.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => cartDrawer.classList.add('is-open'));
    const panel = $('.cart-drawer__panel', cartDrawer);
    if (panel) panel.focus({ preventScroll: true });
  };
  const closeCartDrawer = () => {
    if (!cartDrawer || cartDrawer.hidden) return;
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    const done = () => { cartDrawer.hidden = true; };
    if (reduceMotion) done(); else setTimeout(done, 280);
    if (cartLastFocus && cartLastFocus.focus) cartLastFocus.focus({ preventScroll: true });
  };
  const changeCartLine = async (key, quantity) => {
    const panel = $('.cart-drawer__panel', cartDrawer);
    if (panel) panel.setAttribute('aria-busy', 'true');
    cartError('');
    try {
      const res = await fetch(window.theme.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || window.theme.strings.error);
      await renderCartDrawer();
      refreshCart();
    } catch (err) {
      await renderCartDrawer();
      cartError(err.message || window.theme.strings.error);
    } finally {
      if (panel) panel.removeAttribute('aria-busy');
    }
  };
  if (cartDrawer) {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-drawer-open]');
      if (opener && !e.metaKey && !e.ctrlKey && !e.shiftKey && document.body.classList.contains('template-cart') === false) {
        e.preventDefault();
        renderCartDrawer().then(() => openCartDrawer(opener));
        return;
      }
      if (e.target.closest('[data-cart-drawer-close]')) { closeCartDrawer(); return; }
      const line = e.target.closest('[data-line-key]');
      if (!line || !cartDrawer.contains(line)) return;
      const input = $('[data-cart-qty-input]', line);
      const cur = parseInt(input ? input.value : '0', 10) || 0;
      if (e.target.closest('[data-cart-remove]')) { changeCartLine(line.dataset.lineKey, 0); return; }
      const step = e.target.closest('[data-cart-qty]');
      const ve = input ? parseInt(input.dataset.ve, 10) || 1 : 1;
      if (step) changeCartLine(line.dataset.lineKey, (step.dataset.cartQty === 'plus' ? cur + 1 : cur - 1) * ve);
    });
    cartDrawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      const line = input.closest('[data-line-key]');
      const val = parseInt(input.value, 10);
      const ve = parseInt(input.dataset.ve, 10) || 1;
      if (line) changeCartLine(line.dataset.lineKey, isNaN(val) ? 0 : val * ve);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCartDrawer(); });
  }

  /* ---------- Produktformular: AJAX in den Warenkorb ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      const res = await fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || window.theme.strings.error);
      // Schublade neu zeichnen und öffnen; ohne Schublade (z. B. Theme-Editor) bleibt der Hinweis unten
      if (cartDrawer) {
        await renderCartDrawer();
        openCartDrawer(btn);
      } else {
        showToast((data.quantity ? data.quantity + ' × ' : '') + (data.product_title || '') + ' – ' + window.theme.strings.added);
      }
      refreshCart();
    } catch (err) {
      showToast(err.message || window.theme.strings.error);
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
    }
  });

  /* ---------- Variantenauswahl ---------- */
  $$('[data-product]').forEach((root) => {
    const json = $('[data-product-json]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('input[name="id"]', root);
    const pickers = $$('[data-option-index]', root);

    const currentOptions = () => pickers.map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    const update = () => {
      const opts = currentOptions();
      const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      // Verfügbarkeit der Werte markieren
      pickers.forEach((fs, idx) => {
        $$('.option__value', fs).forEach((lbl) => {
          const val = $('input', lbl).value;
          const test = opts.slice(); test[idx] = val;
          const exists = variants.some((v) => v.options.every((o, i) => o === test[i]));
          lbl.classList.toggle('is-unavailable', !exists);
        });
        const sel = $('[data-option-selected]', fs);
        const checkedOpt = $('input:checked', fs);
        if (sel) sel.textContent = (checkedOpt && checkedOpt.dataset.label) || opts[idx] || '';
      });
      const submit = $('[data-add-button]', root);
      if (!variant) {
        if (submit) { submit.disabled = true; $('[data-add-label]', submit).textContent = S.notAvailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      $$('[data-variant-price]', root).forEach((el) => { el.hidden = String(el.dataset.variantPrice) !== String(variant.id); });
      const sku = $('[data-sku]', root);
      if (sku) sku.textContent = variant.sku || '–';
      const veQty = $('input[data-ve-qty]', root);
      if (veQty && variant.ve && String(variant.ve) !== veQty.dataset.ve) {
        veQty.dataset.ve = variant.ve;
        syncVe($('input[data-ve-count]', root));
        const veLabel = $('[data-ve-label]', root);
        if (veLabel) veLabel.textContent = S.veLabel.replace('__N__', variant.ve);
      }
      if (submit) {
        submit.disabled = !variant.available;
        $('[data-add-label]', submit).textContent = variant.available ? S.addToCart : S.soldOut;
      }
      if (variant.featured_media_id) {
        const thumb = $('[data-media-thumb="' + variant.featured_media_id + '"]', root);
        if (thumb) thumb.click();
      }
      const inquiry = $('[data-inquiry-link]', root);
      if (inquiry) {
        const url = new URL(inquiry.href, window.location.origin);
        url.searchParams.set('produkt', inquiry.dataset.productTitle + ' – ' + variant.title);
        inquiry.href = url.pathname + url.search;
      }
      if (window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) update(); });
    update();
  });

  /* ---------- Mobile Kaufleiste ---------- */
  $$('[data-sticky-buy]').forEach((bar) => {
    const root = bar.closest('[data-product]');
    const form = root && $('form[data-product-form]', root);
    const mainBtn = form && $('[data-add-button]', form);
    if (!mainBtn || !('IntersectionObserver' in window)) return;
    const priceBox = $('[data-sticky-price]', bar);
    const syncPrice = () => {
      const visible = $$('[data-variant-price]', root).find((el) => !el.hidden);
      const line = visible && $('.price__line', visible);
      if (priceBox) priceBox.innerHTML = line ? line.outerHTML : '';
      const add = $('[data-sticky-add]', bar);
      if (add) add.disabled = mainBtn.disabled;
    };
    syncPrice();
    root.addEventListener('change', () => setTimeout(syncPrice, 0));
    new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    }).observe(mainBtn);
    bar.addEventListener('click', (e) => {
      if (!e.target.closest('[data-sticky-add]')) return;
      if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });
  });

  /* ---------- Galerie ---------- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-media-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    const id = thumb.dataset.mediaThumb;
    $$('[data-media-thumb]', gallery).forEach((t) => t.classList.toggle('is-active', t === thumb));
    $$('[data-media-slide]', gallery).forEach((s) => s.classList.toggle('is-active', s.dataset.mediaSlide === id));
  });

  /* ---------- Slider (Produkte & Hero) ---------- */
  $$('[data-slider]').forEach((slider) => {
    const track = $('[data-slider-track]', slider);
    if (!track) return;
    const prev = $('[data-slider-prev]', slider);
    const next = $('[data-slider-next]', slider);
    const dots = $$('[data-slider-dot]', slider);
    const step = () => {
      const first = track.children[0];
      if (!first) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    };
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots.length) {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, j) => { d.classList.toggle('is-active', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    dots.forEach((d, j) => d.addEventListener('click', () => track.scrollTo({ left: j * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' })));
    track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
    sync();

    const autoplay = parseInt(slider.dataset.autoplay || '0', 10);
    if (autoplay > 0 && !reduceMotion && dots.length > 1) {
      let timer;
      const start = () => {
        timer = setInterval(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          const n = (i + 1) % dots.length;
          track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
        }, autoplay * 1000);
      };
      const stop = () => clearInterval(timer);
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      start();
    }
  });

  /* ---------- Filter & Sortierung (Kollektion) ---------- */
  $$('[data-filter-form]').forEach((form) => {
    form.addEventListener('change', () => form.requestSubmit ? form.requestSubmit() : form.submit());
  });
  document.addEventListener('click', (e) => {
    $$('details.filter[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- Kontaktformular: Produkt aus URL vorausfüllen ---------- */
  const params = new URLSearchParams(window.location.search);
  const produkt = params.get('produkt');
  if (produkt) {
    const field = $('[data-prefill-product]');
    if (field && !field.value) field.value = S.inquiryAbout + ' ' + produkt + '\n\n' + S.inquiryQty + ' \n' + S.inquiryDate + ' \n';
    const subject = $('[data-prefill-subject]');
    if (subject && !subject.value) subject.value = S.inquirySubject + ' ' + produkt;
  }

  /* ---------- Händlerantrag: abweichende Rechnungsadresse & Gewerbeschein-Mail ---------- */
  $$('[data-billing-toggle]').forEach((toggle) => {
    const form = toggle.closest('form');
    const box = $('[data-billing]', form);
    const same = $('[data-billing-same]', form);
    if (!box) return;
    const sync = () => {
      box.hidden = !toggle.checked;
      $$('input, select', box).forEach((el) => { el.disabled = !toggle.checked; });
      if (same) same.disabled = toggle.checked;
    };
    toggle.addEventListener('change', sync);
    sync();
  });
  $$('[data-doc-mail]').forEach((link) => {
    const form = link.closest('form');
    const company = form && $('input[name="contact[Firma]"]', form);
    if (!company) return;
    const update = () => {
      const firma = company.value.trim();
      const subject = S.docSubject + (firma ? ' ' + firma : '');
      const body = S.docBody.replace('__FIRMA__', firma);
      link.href = 'mailto:' + link.dataset.docEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    };
    company.addEventListener('input', update);
    update();
  });

  /* ---------- Zähler-Animation ---------- */
  const counters = $$('[data-count-to]');
  const animateCount = (el) => {
    const target = parseFloat(el.dataset.countTo);
    if (isNaN(target) || reduceMotion) return;
    const dur = 1400;
    const t0 = performance.now();
    const fmt = (n) => (target >= 10000 ? Math.round(n).toLocaleString(LANG === 'en' ? 'en-GB' : 'de-DE') : String(Math.round(n)));
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  /* ---------- Scroll-Reveal ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        if (entry.target.matches('[data-count-to]')) animateCount(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-reveal]').forEach((el, i) => {
      el.style.transitionDelay = (el.dataset.revealDelay || 0) + 'ms';
      io.observe(el);
    });
    counters.forEach((el) => io.observe(el));
  } else {
    $$('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Theme-Editor ---------- */
  document.addEventListener('shopify:section:load', () => {
    $$('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
    setVat(document.documentElement.classList.contains('vat-on'));
  });
})();
